import { useState, useMemo } from "react";
import {
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Grid,
    Box
} from "@mui/material";
import { TTipoBaixaFiltros } from "./index";

export default function DialogContentFiltroTipoBaixa({
    handleClose,
    defaultValue,
    onChange
}: DialogContentFiltroTipoBaixaProps) {

    const [filtros, setFiltros] = useState<TTipoBaixaFiltros>(defaultValue);

    const opcoesRadio = useMemo(() => [
        { value: "S", label: "Sim" },
        { value: "N", label: "Não" },
    ], []);

    const handleChange = (campo: keyof TTipoBaixaFiltros, valor: "S" | "N") => {
        setFiltros(prev => ({
            ...prev,
            [campo]: valor
        }));
    };

    const handleConfirmar = () => {
        onChange(filtros);
    };

    const camposFiltro = [
        { key: 'filiais', label: 'Filiais' },
        { key: 'normal', label: 'Normal' },
        { key: 'manual', label: 'Manual' },
        { key: 'extraCaixa', label: 'Extra-Caixa' },
        { key: 'devolucao', label: 'Devolução' },
        { key: 'cancelamento', label: 'Cancelamento' },
        { key: 'substituicao', label: 'Substituição' }
    ];

    return (
        <>
            <DialogTitle>
                Filtros - Tipo de Baixa
            </DialogTitle>
            
            <DialogContent>
                <Box sx={{ pt: 2 }}>
                    <Grid container spacing={3}>
                        {camposFiltro.map((campo) => (
                            <Grid size={{xs: 12, sm: 6}} key={campo.key}>
                                <FormControl>
                                    <FormLabel id={`${campo.key}-label`}>
                                        {campo.label}
                                    </FormLabel>
                                    <RadioGroup
                                        row
                                        aria-labelledby={`${campo.key}-label`}
                                        value={filtros[campo.key as keyof TTipoBaixaFiltros]}
                                        onChange={(e) => handleChange(
                                            campo.key as keyof TTipoBaixaFiltros, 
                                            e.target.value as "S" | "N"
                                        )}
                                    >
                                        {opcoesRadio.map((opcao, index) => (
                                            <FormControlLabel 
                                                key={index} 
                                                value={opcao.value} 
                                                control={<Radio />} 
                                                label={opcao.label} 
                                            />
                                        ))}
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose}>
                    Cancelar
                </Button>
                <Button 
                    onClick={handleConfirmar}
                    variant="contained"
                >
                    Confirmar
                </Button>
            </DialogActions>
        </>
    );
}

interface DialogContentFiltroTipoBaixaProps {
    handleClose: () => void;
    defaultValue: TTipoBaixaFiltros;
    onChange: (value: TTipoBaixaFiltros) => void;
}